import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function IconGem({ color, size }: IIconProps): ReactElement {
  return (
    <svg
      height={size || 16}
      width={size || 16}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.53143 5.35103C1.47571 5.51465 1.49463 5.69515 1.58381 5.84396C1.59529 5.86314 1.60778 5.88152 1.62117 5.89905L7.52727 13.7639C7.63887 13.9125 7.81401 14 8 14C8.18599 14 8.36113 13.9125 8.47273 13.7639L14.3793 5.89845C14.3889 5.88576 14.3981 5.87264 14.4068 5.85909C14.4274 5.82692 14.4447 5.79315 14.4585 5.75829C14.4823 5.6983 14.4958 5.63536 14.4992 5.57204C14.5045 5.4719 14.4843 5.37021 14.4376 5.27705C14.4302 5.26219 14.4222 5.24775 14.4136 5.23373L12.6431 2.28653C12.5363 2.10877 12.3439 2 12.1364 2H3.86364C3.65607 2 3.46373 2.10877 3.35694 2.28653L1.58602 5.23433C1.57984 5.24449 1.57395 5.25486 1.56835 5.26546C1.55369 5.29319 1.54138 5.3218 1.53143 5.35103ZM9.64175 4.95081L6.28297 4.95081L6.6966 3.18033H9.05085L9.64175 4.95081ZM9.65785 6.13115L6.34207 6.13115L7.99996 11.4297L9.65785 6.13115ZM9.58801 10.3116L10.896 6.13115H12.7273L9.58801 10.3116ZM10.8875 4.95081L10.2966 3.18033H11.8018L12.8654 4.95081L10.8875 4.95081ZM5.48304 3.18033L5.06941 4.95081L3.13457 4.95081L4.1982 3.18033H5.48304ZM6.41185 10.3114L5.10389 6.13115H3.27274L6.41185 10.3114Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
